import Service from "./Service";

class StopApiService extends Service {
  constructor() {
    super("api/Stops");
  }

  async getAll() {
    let result = await this.get(``, (status, data) => {
      return data;
    });
    return result;
  }

  async getAllLines() {
    let result = await this.get(`/GetAllLines`, (status, data) => {
      return data;
    });
    return result;
  }

  async getAllStopsOnLine(lineNumber) {
    let result = await this.get(`/GetAllStopsOnLine?lineNumber=${lineNumber}`, (status, data) => {
      return data;
    });
    return result;
  }

  async getDepartureTimeList(departStopNumber, arriveStopNumber, busNumber, departureDate) {
    let result = await this.get(
      `/GetDepartureTimeList?departStopNumber=${departStopNumber}&arriveStopNumber=${arriveStopNumber}&departureDate=${departureDate}&busNumber=${busNumber}`,
      (status, data) => {
        return data;
      }
    );
    return result;
  }
}

export default new StopApiService();
